import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { configureCommons, createCommonsQueryClient } from 'vcode-commons-ui'
import { router } from './routes/router'

configureCommons({
  appName: 'BankManager',
  navLinks: [{ to: '/accounts', label: 'Comptes' }],
  adminLinks: [{ to: '/admin/banks', label: 'Banques a valider' }],
  sessionMinutes: 5,
})

const queryClient = createCommonsQueryClient()

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  )
}
